document.addEventListener("DOMContentLoaded", () => {
  const redirectToHelp = () => {
    if (window.location.href.indexOf("/ca/") > 0)
      window.location.href = "/ca/help#consumer-review-policy";
    else window.location.href = "/help#consumer-review-policy";
  };

  $(".js-help-tooltip").on("click touchstart", ".review-summary-info-link", redirectToHelp);
});
